import React, { useMemo } from "react";
import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { BillingTimeZoneOption, billingTimeZoneOptions } from "../utils/billingTimeZones";

const filterOptions = createFilterOptions<BillingTimeZoneOption>({ stringify: option => option.search });

export default function BillingTimeZoneSettings({ value, onChange, locked = false }: {
  value: string | null; onChange: (timezone: string | null) => void; locked?: boolean;
}) {
  const options = useMemo(() => billingTimeZoneOptions(value), [value]);
  return <Autocomplete size="small" fullWidth options={options} value={options.find(option => option.timezone === value) || null}
    filterOptions={filterOptions} getOptionLabel={option => option.label} isOptionEqualToValue={(a, b) => a.timezone === b.timezone}
    renderOption={({ key, ...props }, option) => <li key={key} {...props}>({option.offset}) {option.timezone}</li>}
    disabled={locked} onChange={(_, option) => onChange(option?.timezone || null)}
    renderInput={params => <TextField {...params} label="Billing timezone" placeholder="Search city, timezone or offset"
      helperText={locked ? "Fixed until this contract ends." : "Used for billing dates and credit expiry. Offsets include daylight saving time."} />} />;
}
